import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Facebook, MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export const StoreFooter = () => {
  const { settings: s } = useSettings();
  const phones = [s.phone, s.phone2, s.phone3].filter(Boolean);
  const waNum = (s.whatsapp || "").replace(/[^0-9]/g, "");

  return (
    <footer className="mt-16 bg-[#14281D] text-stone-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            {s.logo ? (
              <img src={s.logo} alt="logo" className="w-10 h-10 rounded-xl object-cover" />
            ) : (
              <div className="w-10 h-10 rounded-xl bg-[#CA8A04] flex items-center justify-center text-[#1E3A2B] font-bold text-sm">MD</div>
            )}
            <div className="font-bold text-white text-lg">{s.business_name || "M.D.Rice Mill"}</div>
          </div>
          <p className="text-sm text-stone-400 leading-relaxed" data-testid="footer-description">{s.business_description || "মানসম্মত চাল ও ধানজাত পণ্যের বিশ্বস্ত ঠিকানা।"}</p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3">দরকারি লিংক</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-[#CA8A04]">হোম</Link></li>
            <li><Link to="/?category=rice" className="hover:text-[#CA8A04]">চাল</Link></li>
            <li><Link to="/?category=bran" className="hover:text-[#CA8A04]">ব্রান</Link></li>
            <li><Link to="/?category=broken" className="hover:text-[#CA8A04]">খুদ</Link></li>
            <li><Link to="/?category=husk" className="hover:text-[#CA8A04]">তুষ</Link></li>
            <li><Link to="/?category=powder" className="hover:text-[#CA8A04]">গুঁড়া</Link></li>
            <li><Link to="/track" className="hover:text-[#CA8A04]">অর্ডার ট্র্যাক</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3">যোগাযোগ</h4>
          <ul className="space-y-2 text-sm">
            <li className="flex items-start gap-2" data-testid="footer-address"><MapPin size={15} className="mt-0.5" /> {s.address || "ধড়মোকাম, শেরপুর, বগুড়া"}</li>
            {phones.map((ph, i) => (
              <li key={i} className="flex items-center gap-2"><Phone size={15} /> <a href={`tel:${ph}`} data-testid={`footer-phone-${i}`} className="hover:text-[#CA8A04]">{ph}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3">অনুসরণ করুন</h4>
          <div className="flex gap-2">
            {s.facebook && (
              <a href={s.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="w-10 h-10 rounded-xl bg-[#1877F2] flex items-center justify-center text-white"><Facebook size={18} /></a>
            )}
            {waNum && (
              <a href={`https://wa.me/${waNum}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="w-10 h-10 rounded-xl bg-[#25D366] flex items-center justify-center text-white"><MessageCircle size={18} /></a>
            )}
          </div>
          <Link to="/admin/login" className="inline-block mt-4 text-xs text-stone-500 hover:text-[#CA8A04]" data-testid="admin-login-footer-link">অ্যাডমিন প্যানেল →</Link>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-stone-500">
        © {new Date().getFullYear()} {s.business_name || "M.D.Rice Mill"} — সর্বস্বত্ব সংরক্ষিত
      </div>
    </footer>
  );
};

export const FloatingContacts = ({ settings }) => {
  const waNum = (settings?.whatsapp || "").replace(/[^0-9]/g, "");
  if (!waNum) return null;
  return (
    <div className="fixed bottom-5 right-4 z-40 flex flex-col gap-3">
      <a href={`https://wa.me/${waNum}`} target="_blank" rel="noreferrer" data-testid="float-whatsapp" className="w-14 h-14 rounded-full bg-[#25D366] shadow-lg flex items-center justify-center text-white active:scale-90 transition-transform">
        <MessageCircle size={26} />
      </a>
    </div>
  );
};
